import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";

import { auth, firestore } from "./FirebaseService";
import { sendResetPasswordEmail } from "./FunctionService";
import { AuthorizedRoles, PatientRoles } from "../config/DiactiveTypes";

export const isAuthenticated = () => {
  return auth.currentUser !== null;
};

export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

export const signInUser = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  }
  catch (error) {
    throw new Error("Correo electrónico y/o contraseña incorrectos");
  }

  const role = await getAuthUserRole();
  if (!AuthorizedRoles.includes(role)) {
    signOut(auth);
    throw new Error("No tienes permiso para acceder a esta aplicación");
  }
};

export const signOutUser = () => {
  signOut(auth);
};

export const sendPwdResetEmail = async (email) => {
  try {
    await sendResetPasswordEmail(email);
  }
  catch (error) {
    return false;
  }
  return true;
};

export const getAuthUserId = () => {
  return auth.currentUser ? auth.currentUser.uid : null;
};

export const getAuthUserRole = async () => {
  // return Role.Doctor;
  if (!auth.currentUser) return null;

  const docRef = doc(firestore, "users", auth.currentUser.uid);
  const docSnap = await getDoc(docRef);

  const role = docSnap.get("role");
  const isInStudy = docSnap.get("isInStudy");

  if (PatientRoles.includes(role) && !isInStudy) {
    return null;
  }
  return role;
};

export const isAuthUserInStudy = async () => {
  if (!auth.currentUser) return false;

  const docRef = doc(firestore, "users", auth.currentUser.uid);
  const docSnap = await getDoc(docRef);
  return docSnap.get("isInStudy");
};

export const getAuthUserHospital = async () => {
  if (!auth.currentUser) return null;

  const docRef = doc(firestore, "users", auth.currentUser.uid);
  const docSnap = await getDoc(docRef);
  return docSnap.get("hospital");
};